import { Context, type Effect } from "effect";
import type { PreviewRequest, PreviewResult, HostedRequest, HostedResult, ExecutionFailure } from "./model.ts";

export interface ExecutionApiShape {
  readonly preview: (request: PreviewRequest) => Effect.Effect<PreviewResult, ExecutionFailure>;
  readonly tests: (request: HostedRequest) => Effect.Effect<HostedResult, ExecutionFailure>;
}
export class ExecutionApi extends Context.Service<ExecutionApi, ExecutionApiShape>()("workerstation/frontend/ExecutionApi") {}
